import BigNumber from 'bignumber.js';

/**
 * Converts Price/Quantity Increment to expected (int) decimalPlaces.
 *  i.e., Xe-8 => 8.
 * @param {number} increment
 */
export var convertIncrementToIntDecimalPlaces = function convertIncrementToIntDecimalPlaces(increment) {
  if (!increment || increment >= 1) return 0;
  return parseFloat(increment.toExponential().split('-')[1]);
};

/**
 * Ensure value is in units of increment.
 * Better name: "roundDownToNearestIncrement"
 *
 * @param {number} val
 * @param {number} increment
 */
export var incrementUiValue = function incrementUiValue(val, increment) {
  var A = new BigNumber(val);
  var B = new BigNumber(increment);
  return A.minus(A.modulo(B));
};